<template>
  <div>
    <nav class="mui-bar-tab">
      <!-- 在这里放置导航栏 -->
      <div class="nav-row">
        <a class="mui-tab-item" @click="navigate('user')">用户管理</a>
      </div>
      <div class="nav-row">
        <a class="mui-tab-item" @click="navigate('goods')">商品管理</a>
      </div>
      <div class="nav-row">
        <a class="mui-tab-item" @click="navigate('order')">订单管理</a>
      </div>
    </nav>

    <div class="mui-content">
      <router-view></router-view> <!-- 主要内容区域，根据路由渲染不同的组件 -->
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    navigate(route) {
      this.$router.push(`/admin/${route}`);
    }
  }
};
</script>

<style scoped>
.nav-row {
  margin: 40px;
}

nav a.mui-tab-item {
  padding: 10px 15px;
  border-radius: 5px;
  background-color: #ff9900;
  color: #fff;
}
</style>
